<template>
    <section class="py-2">
        <level-modal/>
        <div class="container">
            <h3>회원 메뉴</h3>

            <br/>
            <div class="row">
                <div class="col-md-12 ">
                    <nav>
                        <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                            <a class="nav-item nav-link active nav_title" id="nav-home-tab" data-toggle="tab" href="#nav-home"
                               role="tab" aria-controls="nav-home" aria-selected="true">내정보</a>
                            <a class="nav-item nav-link nav_title" id="nav-activity-tab" data-toggle="tab" href="#nav-activity"
                               role="tab" aria-controls="nav-activity" aria-selected="false">나의활동</a>
                            <a class="nav-item nav-link nav_title" id="nav-alarm-tab" data-toggle="tab" href="#nav-alarm"
                               role="tab" aria-controls="nav-alarm" aria-selected="false">활동알림</a>
                            <!--<a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile"
                               role="tab" aria-controls="nav-profile" aria-selected="false">신청활동</a>
                            <a class="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact"
                               role="tab" aria-controls="nav-contact" aria-selected="false">관심활동</a>-->
                        </div>
                    </nav>
                    <div class="tab-content py-3 px-3 px-sm-0" id="nav-tabContent" style="border: 1px solid #dee2e6; border-top: none; background-color: #fff">
                        <div class="tab-pane fade show active" id="nav-home" role="tabpanel"
                             aria-labelledby="nav-home-tab">
                            <div class="container text-center">
                                <img  @error="member.profileImage=require('@/assets/img/profile_base.png')" :src="member.profileImage ?  member.profileImage : require('@/assets/img/profile_base.png')" alt="profile Image" style="width:120px; height:120px; margin-bottom:10px; position: relative; margin-left: 12px; object-fit: cover;" class="img-profile rounded-circle">
                                <i class="fa fa-camera fa-fw  imgcog_icon" @click="profileModified=!profileModified"></i><br>
                                <input v-if="profileModified" type="file" ref="profileImage" @change="onFileChange" multiple />
                                <button @click="memberModified('profileModified')" class="btn-sm" v-if="profileModified">확인</button>
                                <br>

                                <span class= "name" v-if="!nameModifed">{{member.name}} 님</span>
                                <button :class="nameModifed ? 'btn btn-sm input_icon' : 'btn btn-sm'" style="right : 27% !important; padding-top : 0;" @click="nameModifed ? memberModified('nameModifed') : nameModifed=!nameModifed">
                                    <i :class="nameModifed ? 'fa fa-check fa-fw' : 'fa fa-pencil fa-fw'" style="position: relative;"></i>
                                </button>
                                <div class="input-group">
                                    <input v-if="nameModifed" placeholder="이름"  class="form-control name-form" style="z-index: 1;" v-model="member.name"/>
                                </div>
                                <!--<input type="text" v-if="birthdayModify" class="form-control" placeholder="생년월일" maxlength="8" v-model="member.age"/>-->
                                <span class="sub_name">{{member.genderName}} / {{$root.$children[0].getAgeString(member.age)}}</span>
                                <div>

                                </div>
                                <br/>
                                <!-- <button class="btn btn-white" href="#none;">회원 정보 수정</button> / -->
                                <table class="table container">
                                    <tbody>
                                        <tr>
                                            <td class="align-middle info-title" style="font-weight: 600;">생년월일</td>
                                            <td class="info-contents">
                                                <span v-if="!birthdayModify">{{birthdatDate(member.age)}}</span>
                                                <button :class="birthdayModify ? 'btn btn-sm input_icon' : 'btn btn-sm'" @click="birthdayModify ? memberModified('birthdayModify') : birthdayModify=!birthdayModify">
                                                    <i :class="birthdayModify ? 'fa fa-check fa-fw' : 'fa fa-pencil fa-fw'" style="position: relative;"></i>
                                                </button>
                                                <!--<input type="text" v-if="birthdayModify" class="form-control" placeholder="생년월일" maxlength="8" v-model="member.age"/>-->
                                                <div class="input-group">
                                                    <datePicker  v-if="birthdayModify" class="form-control" placeHolder="생일" v-model="member.age" :config="options" ></datePicker>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle info-title" style="font-weight: 600;" colspan="2">
                                                <div class="row">
                                                    <label class="col">특기</label>
                                                    <div class="col">
                                                        <button class="btn btn-sm float-right info-contents col" @click="spModified ? memberModified('spModified') : spModified=!spModified" >
                                                             <i :class="spModified ? 'fa fa-check fa-fw' : 'fa fa-pencil fa-fw'" ></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div v-if="!spModified && member.specialities.length > 0" class="row" style="margin-left: auto">
                                                    <div v-for="spec in member.specialities" class="rounded spe_border spe">
                                                        {{specialities[spec]}}
                                                    </div>
                                                </div>
                                                <div v-if="!spModified && !member.specialities.length">
                                                    <div class="rounded spe_border spe">
                                                        없음
                                                    </div>
                                                </div>
                                                <div v-if="spModified" class="form-group form-check form-check-inline"  v-for="(item, index) in specialities">
                                                    <input type="checkbox" class="form-check-input" :id="index" :value="index" v-model="member.specialities">
                                                    <label class="form-check-label" :for="index">{{item}}</label>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle info-title" style="font-weight: 600;">
                                                전화번호
                                            </td>
                                            <td class="info-contents">
                                              <div class="vstack">
                                                <div class="d-flex justify-content-end" style="margin-bottom: 5px;">
                                                  <span v-if="!phoneModified">{{member.phoneNumber}}</span>
                                                  <button v-if="!phoneModified && !isPhoneAuthModified" class="btn btn-sm" @click="phoneNumberModified()">
                                                    <i :class="phoneModified ? 'fa fa-check fa-fw' : 'fa fa-pencil fa-fw'"></i>
                                                  </button>

                                                  <div class="d-flex justify-content-end" v-if="phoneModified && !isSmsSended">
                                                    <input type="text" class="form-control" placeholder="휴대폰 번호" maxlength="13" v-model="member.phoneNumber" @keyup="autoHypen(member.phoneNumber)" style="max-width: 200px;"/>
                                                    <button type="button" class="btn" :class="isPhoneDuplicatedChecked ? 'btn-primary' : 'btn-outline-primary'" style="margin-left: 5px;"
                                                            @click="checkPhoneDuplicated()">변경하기</button>
<!--                                                    <input type="button" class="btn fa-check fa-fw" @click="authorPhoneMsg()"/>-->
                                                  </div>
                                                </div>
                                                <div class="d-flex justify-content-end" v-if="!phoneModified">

                                                  <input v-if="isPhoneAuthModified" type="number" placeholder="인증번호"  class="form-control" v-model="smsAuthCode" style="z-index: 1"/>
                                                  <input v-if="isPhoneAuthModified" type="button" class="btn btn-primary"
                                                         @click="isSmsSended ? authorizePhone() : sendAuthSms()"
                                                         :value="isSmsSended ? '확인' : '인증번호 전송'" style="margin-left: 5px;" />
<!--                                                  <input v-if="isSmsSended" type="button" class="btn btn-white icon" @click="authorizePhone" value="인증"/>-->

                                                  <span v-if="member.isPhoneAuthorized" style="color:#0077ff; font-size:14px;">{{member.isPhoneAuthorized ? '인증됨' : '미인증'}}</span>
                                                  <button v-if="!member.isPhoneAuthorized && !isPhoneAuthModified" type="button" class="btn btn-sm btn-outline-primary" style="border-radius: 20px;"
                                                          @click="isPhoneAuthModified = true;">인증하기</button>
                                                </div>
                                              </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle info-title" style="font-weight: 600;">이메일 </td>
                                            <td class="info-contents">
                                                    {{member.email}}
                                                <br/><span style="color:#0077ff; font-size:14px;">{{member.isEmailAuthorized ?  '인증됨' : '미인증'}}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle info-title" style="font-weight: 600;" colspan="2">
                                                <div class="row">

                                                    <label class="col">자기소개</label>
                                                    <div class="col">
                                                        <button class="btn btn-sm float-right info-contents col" @click="introModified ? memberModified('introModified') : introModified=!introModified">
                                                            <i :class="introModified ? 'fa fa-check fa-fw' : 'fa fa-pencil fa-fw'"/>
                                                        </button>
                                                    </div>
                                                    <p class="input-group introduce" v-if="!introModified">{{member.introduce}}</p>
                                                    <textarea class="form-control" v-model="member.introduce" v-if="introModified"></textarea>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle info-title" style="font-weight: 600;">OT 수강<br/>(카라 더봄센터 봉사를 위한 사전교육 수강)</td>
                                            <td class="info-contents">
                                                <span>{{member.isEducatedOT ? '수강함' : '미수강'}}</span>
                                                <!--
                                                <span v-if="eduModified">
                                                    <input type="radio" v-model="member.isEducatedOT" value="true" v-if="eduModified"/> 수강함
                                                    <input type="radio" v-model="member.isEducatedOT" value="false" v-if="eduModified"></input> 미수강
                                                </span>
                                                <button class="btn btn-sm float-right info-contents col" @click="eduModified ? memberModified('eduModified') : eduModified=!eduModified">
                                                    <i :class="eduModified ? 'fa fa-check fa-fw' : 'fa fa-pencil fa-fw'"/>
                                                </button>-->

                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle info-title" style="font-weight: 600;">봉사시간</td>
                                            <td class="info-contents">
                                                {{parseInt(member.volunteerMinute/60)}} 시간
                                                <span class="badge badge-pill" :style="`color:white;background-color:`+($root.$children[0].getLevelByMinute($auth.user().volunteerMinute) ? $root.$children[0].getLevelByMinute($auth.user().volunteerMinute).color : '#6c757d')">
                                                    {{$root.$children[0].getLevelByMinute($auth.user().volunteerMinute) ? $root.$children[0].getLevelByMinute($auth.user().volunteerMinute).name : '새내기'}}
                                                </span>
                                                <br>
                                                <button class="btn btn-sm btn-outline-primary mt-2" style="border-radius: 20px;" @click="levelInfo()">더 알아보기</button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle info-title" style="font-weight: 600;">카라 회원 여부(정기후원)</td>
                                            <td class="info-contents">
                                                {{member.isKaraRegularMember ? "정기후원(카라 회원) 확인되었습니다." : "정기후원이 확인되지 않았습니다. 카라 가입시 등록하신 핸드폰번호로 정보 변경후 확인해주세요."}}
                                                <a v-if="!member.isKaraRegularMember" class="btn btn-sm btn-outline-primary" style="border-radius: 20px;" target="_blank" href="https://mrmweb.hsit.co.kr/v2/Member/MemberJoin.aspx?action=join&server=Oi9Q0GmPr%20jA9BgBmeoL%20g==&supportgroup=6">가입하러가기</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle info-title" style="font-weight: 600;">사회복지자원봉사인증관리(VMS) 아이디</td>
                                            <td class="info-contents">
                                                <div class="row" style="float:right;">
                                                    <span v-if="!vmsIdModify">{{member.vmsId}}</span>
                                                    <input v-else class="form-control col-8" placeHolder="VMS 아이디" v-model="member.vmsId" />
                                                    <button class="" :class="vmsIdModify ? 'btn btn-sm input_icon' : 'btn btn-sm'" @click="vmsIdModify ? memberModified('vmsIdModify') : vmsIdModify=!vmsIdModify">
                                                        <i :class="vmsIdModify ? 'fa fa-check fa-fw' : 'fa fa-pencil fa-fw'"></i>
                                                    </button>
                                                </div>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <hr/>
                                <div style="text-align:right; color:#acb0b6;">
                                    <router-link :to="{name : 'changepw'}" class="withdrawal text-right">비밀번호 번경</router-link>
                                    &nbsp; | &nbsp;
                                    <router-link :to="{name : 'withdraw'}" class="withdrawal text-right">회원 탈퇴</router-link>
                                </div>
                            </div>

                        </div>

                        <div class="tab-pane fade" id="nav-activity" role="tabpanel" aria-labelledby="nav-activity-tab">
                            <span class= "name" style="font-size:15px; color:#626466;">{{member.name}} 님의 봉사활동 시간</span>
                            <div class="my_act">
                            <MyLevel :moreInfo="true" ></MyLevel>
                            </div>
                            <br>
                            <br>

                            <nav>
                                <div class="nav nav-fill nav-pills" id="nav-tab2" role="tablist">
                                    <a class="nav-item nav-link active nav_title" id="nav-regist-tab" data-toggle="tab" href="#nav-profile"
                                       role="tab" aria-controls="nav-profile" aria-selected="true">신청활동</a>
                                    <a class="nav-item nav-link nav_title" id="nav-interest-tab" data-toggle="tab" href="#nav-contact"
                                       role="tab" aria-controls="nav-contact" aria-selected="false">관심활동</a>
                                </div>
                            </nav>
                            <div class="tab-content py-3 px-3 px-sm-0" id="nav-tabContent2">


                                <div class="tab-pane fade show active" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                                    <ActivityListWide :page="search.page" :size="search.size" :registMemberId="member.id"/>
                                </div>
                                <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                    <ActivityListWide :page="search.page" :size="search.size" :interMemberId="member.id"/>
                                </div>
                            </div>


                        </div>

                        <div class="tab-pane fade" id="nav-alarm" role="tabpanel" aria-labelledby="nav-alarm-tab">
                            <span class= "name" style="font-size:15px; color:#626466;">{{member.name}} 님의 활동 내역 <br>(*최근 100개까지의 알림이 표시됩니다.)</span>
                            <br><br>
                            <nav>
                                <div class="nav nav-fill nav-pills" id="nav-tab3" role="tablist">
                                    <a class="nav-item nav-link active nav_title" id="nav-alarms-tab" data-toggle="tab" href="#nav-alarms"
                                       role="tab" aria-controls="nav-profile" aria-selected="true">활동 알림</a>
                                    <a class="nav-item nav-link nav_title" id="nav-exp-tab" data-toggle="tab" href="#nav-exp"
                                       role="tab" aria-controls="nav-contact" aria-selected="false">봉사시간 알림</a>
                                </div>
                            </nav>
                            <div class="tab-content py-3 px-3" id="nav-tabContent3">
                                <div class="tab-pane fade show active" id="nav-alarms" role="tabpanel" aria-labelledby="nav-profile-tab">
                                    <AlarmList :memberId="$auth.user().id" :msgOnly="false"></AlarmList>
                                </div>
                                <div class="tab-pane fade" id="nav-exp" role="tabpanel" aria-labelledby="nav-contact-tab">
                                    <AlarmList :memberId="$auth.user().id" :msgOnly="true"></AlarmList>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

    </section>
</template>
<script>
    //import moment from 'moment';
    import ActivityListWide from '@/components/activity/ActivityListWide.vue'
    import AlarmList from '@/components/member/AlarmList.vue'
    import LevelModal from '@/components/LevelModal.vue'
    import MyLevel from '@/components/MyLevel.vue'
    import moment from 'moment';
    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    export default {
        name: 'mypage',
        components: {
          ActivityListWide, AlarmList, LevelModal, MyLevel, datePicker
        },
        data() {
            return {
                options: {
                    format: 'YYYYMMDD',
                    useCurrent: true,
                    locale: 'ko'
                },
                repassword: '',
                specialities: [],
                search: {
                    page:"0",
                    size:"4",
                    query:""
                },
                isSmsSended : false,
                smsAuthCode : '',
                spModified : false,
                phoneModified : false,
                introModified : false,
                profileModified : false,
                birthdayModify: false,
                vmsIdModify: false,
                eduModified: false,
                nameModifed: false,
                isPhoneAuthModified : false,
                member : {
                    specialities:[],
                },
            };
        },
        methods: {

            getAddress(addr) {
                this.member.address = addr;
            },
            popupPostcode() {
                this.$modal.show(Postcode,{
                    modal : this.$modal },{
                    width : '330px',
                    height : 'auto',
                    scrollable: true,
                })
            },
            getSpecialityMap() {
                let me = this;
                this.axios.get(process.env.VUE_APP_MEMBER_API_URL + '/speciality') //JSON.parse(JSON.stringify(this.member))
                    .then(function (res) {
                        me.specialities = res.data;
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },
            getMemberdata() {
                let me = this;
                this.axios.get(process.env.VUE_APP_MEMBER_API_URL + `/${me.$auth.user().id}`)
                    .then(function (res) {
                        me.member = res.data;
                        me.member.age = me.member.age+"";
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },
            sendAuthSms() {
                let me = this;

                this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/phone/${this.member.phoneNumber}`)
                    .then(function (res) {
                        if(res.data) {
                            me.$root.$children[0].commonDialog('본인인증','문자가 발송 되었습니다. ')
                            me.isSmsSended = true
                        }
                    }).catch(function (error) {
                    //console.log(error);
                    me.$root.$children[0].commonDialog('휴대폰 번호를 확인해주세요.')
                    return;
                });
            },
            authorizePhone() {
                let me = this;

                if (!this.smsAuthCode) {
                    this.$root.$children[0].commonDialog('인증번호를 입력해주세요.')
                    return;
                }

                this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/phone/${this.member.phoneNumber}/${this.smsAuthCode}`)
                    .then(function (res) {
                        if(res.data.isPhoneAuthorized) {
                            me.isSmsSended = false;
                            me.member.isPhoneAuthorized = true;
                            me.$root.$children[0].commonDialog('본인인증','인증 되었습니다. ')
                            me.$auth.user().isPhoneAuthorized = res.data.isPhoneAuthorized;

                            me.isPhoneAuthModified = false;
                        } else {
                            me.$root.$children[0].commonDialog('본인인증','인증에 실패하였습니다. 다시 시도해주세요. (최대5회) ')
                        }
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },
            memberModified(nowModifiedField) {
                this[nowModifiedField] = false;
                this.member.age = this.member.age+"";
                let me = this;

                this.axios.put(process.env.VUE_APP_MEMBER_API_URL, this.member)
                    .then(function (res) {
                        me.member = res.data;
                        me.$root.$children[0].commonDialog('개인정보','수정 되었습니다.');
                    }).catch(function (error) {
                    console.log(error);
                    alert('등록 에러');
                });
            },
            authorPhoneMsg(){
                if(this.member.isPhoneAuthorized) {
                    this.member.isPhoneAuthorized = true;
                    this.isSmsSended = false;
                    this.memberModified('phoneModified')
                }else
                    this.$root.$children[0].commonDialog('휴대폰 인증을 진행해주세요.')
            },
            phoneNumberModified() {
                this.$modal.show('dialog', {
                    title: '정보수정',
                    text: '휴대폰 번호 변경 시 휴대폰 인증을 다시 하셔야 합니다. <br>정말 수정하시겠습니까?',
                    buttons: [
                        {
                            title: '수정',
                            handler: () => {
                                this.phoneModified = true;
                                this.member.isPhoneAuthorized = false;
                                this.$modal.hide('dialog');
                            }
                        },
                        {
                            title: '취소'
                        },
                    ]
                })
            },
            checkPhoneDuplicated() {
              if(this.member.phoneNumber == '' || this.member.phoneNumber.length < 11) {
                alert("휴대폰 번호 형식이 올바르지 않습니다.");
                return false;
              }
              let me = this;

              this.axios.get(process.env.VUE_APP_AUTH_API_URL + `/exist/phone/${me.member.phoneNumber}`)
                  .then(function (res) {
                    if (res.data) {
                      me.$root.$children[0].commonDialog('알림','이미 존재하는 핸드폰 번호입니다.')
                    } else {
                      // me.$root.$children[0].commonDialog('중복확인','사용가능한 핸드폰 번호입니다.')
                      me.memberModified('phoneModified');
                    }
                  }).catch(function (error) {
                //console.log(error);
                alert(error);
              });
            },

            autoHypen(num) {

                let number = num.replace(/[^0-9]/gi,'');
                let phone = "";

                if(number.length < 4) {
                    phone = number;
                } else if(number.length < 7) {
                    phone += number.substr(0, 3);
                    phone += "-";
                    phone += number.substr(3);
                } else if(number.length < 11) {
                    phone += number.substr(0, 3);
                    phone += "-";
                    phone += number.substr(3, 3);
                    phone += "-";
                    phone += number.substr(6);
                } else {
                    phone += number.substr(0, 3);
                    phone += "-";
                    phone += number.substr(3, 4);
                    phone += "-";
                    phone += number.substr(7);
                }
                this.member.phoneNumber = phone;
            },
            resizeImg(file) {
                let me = this;
                let maxSize = 240; // 이미지 크기 증가
                let reader = new FileReader();
                let image = new Image();
                let canvas = document.createElement('canvas');
                let dataURItoBlob = function (dataURI) {
                    let bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
                        atob(dataURI.split(',')[1]) :
                        unescape(dataURI.split(',')[1]);
                    let max = bytes.length;
                    let ia = new Uint8Array(max);
                    for (let i = 0; i < max; i++)
                        ia[i] = bytes.charCodeAt(i);
                    return new Blob([ia], { type: 'image/jpeg'});
                };
                let resize = function () {
                    let width = image.width;
                    let height = image.height;
                    if (width > height) {
                        if (width > maxSize) {
                            height *= maxSize / width;
                            width = maxSize;
                        }
                    } else {
                        if (height > maxSize) {
                            width *= maxSize / height;
                            height = maxSize;
                        }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    let ctx = canvas.getContext('2d');
                    // 이미지 품질 개선을 위한 설정
                    ctx.imageSmoothingEnabled = true;
                    ctx.imageSmoothingQuality = 'high';
                    ctx.drawImage(image, 0, 0, width, height);
                    let dataUrl = canvas.toDataURL('image/jpeg', 0.92); // 품질 92%로 설정
                    me.member.profileImage = dataUrl;

                    me.makeUploadFiles([dataURItoBlob(dataUrl)], function(res){
                        me.member.profileImage = res;
                        return res;
                    })
                    return dataURItoBlob(dataUrl);
                };
                return new Promise(function (ok, no) {
                    if (!file.type.match(/image.*/)) {
                        no(me.$root.$children[0].commonDialog('프로필 등록', '이미지만 등록가능합니다.'))
                        return;
                    }
                    reader.onload = function (readerEvent) {
                        image.onload = function () { return ok(resize()); };
                        image.src = readerEvent.target.result;

                    };
                    reader.readAsDataURL(file);
                });
            },
            birthdatDate(birth){
                return moment(`${birth}`).format('YYYY년MM월DD일');
            },
            onFileChange(e) {
                const file = e.target.files[0];
                this.resizeImg(file)
            },
            removeImage: function () {
                this.$refs.profileImage.value = '';
                this.member.profileImage = '';
            },
            async makeUploadFiles(files, callback) {
                let formData = new FormData();
                for (let i = 0; i < files.length; ++i) {
                    formData.append('sourceFile', files[i]);
                }
                this.$root.$children[0].uploadFile(formData, 'PROFILE').then(callback);
            },
            levelInfo(){
                this.$modal.show('LevelModal')
            },


        },
        computed: {},
        mounted() {
            this.getSpecialityMap();
            this.getMemberdata()
        },
        watch:{
            "member.phoneNumber" : function(val){
                const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;

                if(reg.exec(val)!==null){
                    return this.member.phoneNumber = this.member.phoneNumber.slice(0,-1);
                }
            }
        }
    };
</script>
<style scoped>

    .container{
        max-width:800px !important;
    }

    td {
        width: 50%;
    }
    .info-title{
        text-align: left;
        color: #989898;
    }
    .info-contents{
        text-align: right;
    }
    .name-form{
        max-width : 50% !important;
        margin: auto;
    }

    @media (max-width: 576px) {
        td {
            width : 100%;
        }
        .icon{
            padding-right: 5px;
            color:dodgerblue;
        }
        .input_icon{
            right: 55px !important;
        }

        .name-form{
            max-width : 55% !important;
            margin: auto;
        }
    }
    .input_icon {
        position: absolute;
        right: 43px;
        margin-top: 4px;
        margin-right: 0px;
        z-index: 2;
    }

    .name{
        font-size:19px;
        font-weight: bold;
        margin-left: 1.9%;
    }

    .withdrawal{
        font-size:15px;
        color:#acb0b6;

    }
    .nav-link.active{
        color: #007bff;
    }
    .nav_title {
        color: #343a40;
        font-weight: 500;
        transition: all 0.2s ease;
    }
    .nav_title:hover {
        color: #007bff;
    }
    .sub_name {
        color: #888888;
        font-weight: 600;
        font-size: 14px;
    }

    .my_act {
        border-radius: 12px;
        border: 1px solid #e9ecef;
        background: #fff;
        padding: 20px;
        margin: 1.5rem 0;
        box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        transition: all 0.3s ease;
    }
    .my_act:hover {
        box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    }
    .imgcog_icon{
        position: relative;
        bottom: -20px;
        right: 15px;
    }
    .spe{
        flex: 0 0 31%;
        max-width: 31%;
        margin: .5%;
        text-align: center;
        font-size:13px;
        margin-top: 5px !important;
        height: 30px;
        line-height: 2.2em;
        color: #757575;
        font-weight: 600;
    }
    .spe_border{
        border: 1px solid #ebebeb;
        box-shadow: 1.5px 1.5px 1.5px #ebebeb;
        border-radius: 3px!important;
    }
    .introduce{
        border: 1px solid #f5f5f5;
        border-radius: 5px;
        background-color: #f5f5f5;
        word-break:break-all;
        padding: 1em;
        color: black;
        font-weight: 400;
    }
    .nav-pills .nav-link.active {
        background-color: #fff;
        border-radius: 8px;
        border: 2px solid #007bff;
        color: #007bff !important;
        font-weight: 600;
    }
    
    .tab-content {
        background-color: #fff;
        border-radius: 12px;
        padding: 20px;
        margin-top: 1rem;
        box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    }

    #nav-tabContent2, #nav-tabContent3 {
        border: 1px solid #e9ecef;
        border-radius: 8px;
        margin-top: 1rem;
    }

    /* 모바일 대응 */
    @media (max-width: 576px) {
        .my_act {
            margin: 1rem 0;
            padding: 15px;
        }
        
        .tab-content {
            padding: 15px;
        }

        .nav-pills .nav-link {
            padding: 8px 12px;
            font-size: 14px;
        }
    }
</style>